import { useQuery } from '@tanstack/react-query';
import {
  getIncidents,
  getIncidentDetail,
  getIncidentEvents,
} from '../../services/incidents.service';
import type {
  IncidentFilters,
  IncidentEventsParams,
} from '../../services/incidents.service';

// =============================================================================
// Query Key Factory
// =============================================================================

export const incidentKeys = {
  all: ['incidents'] as const,
  lists: () => [...incidentKeys.all, 'list'] as const,
  list: (filters: IncidentFilters) => [...incidentKeys.lists(), filters] as const,
  details: () => [...incidentKeys.all, 'detail'] as const,
  detail: (id: number) => [...incidentKeys.details(), id] as const,
  events: (id: number, params: IncidentEventsParams) =>
    [...incidentKeys.detail(id), 'events', params] as const,
};

// =============================================================================
// Incident Hooks
// =============================================================================

export function useIncidents(filters: IncidentFilters = {}) {
  return useQuery({
    queryKey: incidentKeys.list(filters),
    queryFn: () => getIncidents(filters),
    placeholderData: (previousData) => previousData,
  });
}

export function useIncidentDetail(id: number) {
  return useQuery({
    queryKey: incidentKeys.detail(id),
    queryFn: () => getIncidentDetail(id),
    enabled: !!id,
  });
}

export function useIncidentEvents(id: number, params: IncidentEventsParams = {}) {
  return useQuery({
    queryKey: incidentKeys.events(id, params),
    queryFn: () => getIncidentEvents(id, params),
    enabled: !!id,
  });
}
